// extracted by mini-css-extract-plugin
export default {"root":"UserTable_root__ex7fz","content":"UserTable_content__-l5jW"};